"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserVerifier = void 0;
const userKeys_1 = require("./userKeys");
/**
 * ed25519 signature verification
 */
class UserVerifier {
    constructor(publicKey) {
        this.publicKey = publicKey;
    }
    static fromAddress(address) {
        let publicKey = new userKeys_1.UserPublicKey(address.pubkey());
        return new UserVerifier(publicKey);
    }
    /**
     *
     * @param data the raw data to be verified (e.g. an already-serialized enveloped message)
     * @param signature the signature to be verified
     * @returns true if the signature is valid, false otherwise
     */
    verify(data, signature) {
        return this.publicKey.verify(data, signature);
    }
}
exports.UserVerifier = UserVerifier;
//# sourceMappingURL=userVerifier.js.map